<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '../ui-utils.ts';

const props = defineProps<{
  class?: HTMLAttributes['class'];
}>();
</script>

<template>
  <th
    :class="
      cn('h-12 px-4 text-left align-middle font-medium text-slate-500 [&:has([role=checkbox])]:pr-0', props.class)
    "
  >
    <slot />
  </th>
</template>
